// src/config/pillars.js
// Single source of truth for the seven pillars of cross-border cashflow management.
// Consumers: Sidebars, LandingPage (PillarStrip), ProductsPage, AboutPage, Footer,
//            ForwardsflowAdminDashboard (health strip), roleConfig (dashboardTabs).

export const PILLARS = Object.freeze([
  {
    key: 'yield_discovery',
    n: 1,
    label: 'Yield discovery',
    short: 'Yield',
    icon: 'Percent',
    blurb: 'Compare structural frontier yields against your home benchmark, net of fees and FX.',
    investorPath: 'yield',
    bankRoles: ['bank_admin'],
    adminMetric: 'markets_live',
  },
  {
    key: 'exchange_rates',
    n: 2,
    label: 'Exchange rates',
    short: 'Rates',
    icon: 'ArrowRightLeft',
    blurb: 'Live spot, forward curves and competitive bank quotes via RFQ.',
    investorPath: 'rates',
    bankRoles: ['bank_treasury_dealer'],
    adminMetric: 'open_fx_rfqs',
  },
  {
    key: 'compliance',
    n: 3,
    label: 'Compliance fulfilment',
    short: 'Compliance',
    icon: 'ClipboardCheck',
    blurb: 'Remote KYC, CDS account opening and per-market rule sets — maker/checker controlled.',
    investorPath: 'compliance',
    bankRoles: ['bank_compliance_maker', 'bank_compliance_checker'],
    adminMetric: 'kyc_backlog',
  },
  {
    key: 'hedging',
    n: 4,
    label: 'Hedging devices',
    short: 'Hedging',
    icon: 'Shield',
    blurb: 'Pooled forwards, hedge ratios and FX overlay to lock in your exit rate.',
    investorPath: 'hedging',
    bankRoles: ['bank_forwards_dealer'],
    adminMetric: 'open_hedges_notional',
  },
  {
    key: 'liquidity',
    n: 5,
    label: 'Liquidity preservation',
    short: 'Liquidity',
    icon: 'Droplets',
    blurb: 'Maturity ladders, rollover instructions, netting and a secondary market for early exit.',
    investorPath: 'liquidity',
    bankRoles: ['bank_admin'],
    adminMetric: 'maturing_30d',
  },
  {
    key: 'execution',
    n: 6,
    label: 'Transaction execution',
    short: 'Execution',
    icon: 'Zap',
    blurb: 'Auction bids, settlement instructions and CSD confirmation with a full lifecycle audit trail.',
    investorPath: 'execution',
    bankRoles: ['bank_treasury_dealer'],
    adminMetric: 'settlements_today',
  },
  {
    key: 'portfolio',
    n: 7,
    label: 'Portfolio management',
    short: 'Portfolio',
    icon: 'Briefcase',
    blurb: 'Holdings, performance, risk, FX overlay, governance and projections in one view.',
    investorPath: 'portfolio',
    bankRoles: [],
    adminMetric: 'aum',
  },
]);

export const PILLAR_BY_KEY = Object.fromEntries(PILLARS.map(p => [p.key, p]));
